module.exports = __webpack_public_path__ + "static/media/HabitMaker.8c208413.svg";